//@ts-check
import { getFileContracts } from "../../utils/get-file-contract"

/**
 * @param files {{
 * files:scr.file[]
 * mainFile:string
 * mainContract:string
 * }
 */
export default function isSelectedContractExists({
  files,
  mainFile,
  mainContract,
}) {
  let isContractSelected
  for (const file of files) {
    const fileContracts = getFileContracts(file.content)
    if (
      file.path === mainFile &&
      fileContracts.asObject[mainContract] !== undefined
    ) {
      isContractSelected = true
      break
    }
  }
  return isContractSelected
}
